export default __webpack_public_path__ + "static/media/89.c33995f3.jpeg";